"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn Lazyan.
 * @since 2.1.0
 */
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var ErrorObservable_1 = require("rxjs/observable/ErrorObservable");
var operators_1 = require("rxjs/operators");
var auth_settings_config_1 = require("../auth-settings.config");
var token_info_service_1 = require("./token-info.service");
var token_utilities_1 = require("./token.utilities");
var cookie_service_1 = require("../../cookie-service");
/**
 * Interceptor for Http 401 requests.
 * You need to register it in your modules providers list.
 */
var UnauthorizedInterceptor = /** @class */ (function () {
    function UnauthorizedInterceptor(tokenInfoService, cookieService) {
        this.tokenInfoService = tokenInfoService;
        this.cookieService = cookieService;
    }
    UnauthorizedInterceptor.prototype.intercept = function (req, next) {
        var _this = this;
        if (req.url.includes(auth_settings_config_1.AuthSettings.OAUTH_SERVICE_CHECK_TOKEN_ENDPOINT) ||
            req.url.includes(auth_settings_config_1.AuthSettings.OAUTH_SERVICE_TOKEN_ENDPOINT) ||
            req.url.includes(auth_settings_config_1.AuthSettings.LOGIN_ENDPOINT) ||
            req.url.includes(auth_settings_config_1.AuthSettings.OAUTH_SERVICE_USERDATA_ENDPOINT)) {
            return next.handle(req);
        }
        return next.handle(req).pipe(operators_1.tap(function (event) {
            if (event instanceof http_1.HttpResponse) {
                if (event.status !== 401 &&
                    (req.headers.has('Authorization') ||
                        req.headers.has('X-XSRF-TOKEN') ||
                        (req.body && req.body['access_token']))) {
                    _this.tokenInfoService.tokenValiditySubject.next(true);
                }
            }
        }), operators_1.catchError(function (err) {
            if (err instanceof http_1.HttpErrorResponse && err.status === 401) {
                _this.tokenInfoService.tokenValiditySubject.next(false);
                return _this.tokenInfoService.tokenUpdatedViaQuickLogin.pipe(operators_1.first(), operators_1.switchMap(function (updated) {
                    return updated
                        ? next.handle(token_utilities_1.addToken(req, _this.cookieService))
                        : ErrorObservable_1.ErrorObservable.create(err);
                }));
            }
            return ErrorObservable_1.ErrorObservable.create(err);
        }));
    };
    UnauthorizedInterceptor = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [token_info_service_1.TokenInfoService,
            cookie_service_1.CookieService])
    ], UnauthorizedInterceptor);
    return UnauthorizedInterceptor;
}());
exports.UnauthorizedInterceptor = UnauthorizedInterceptor;
//# sourceMappingURL=unauthorized-interceptor.js.map